import React, { useEffect } from 'react'
import { Form, Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import BudgetDriverForm from './BudgetDriverForm'
import { BudgetDriver } from '../../../../../../types/budgetDriver/BudgetDriver'
import { useCreateBudgetDriver } from '../../../../../../features/budgetDrivers/queries/useCreateBudgetDriver'
import { useUpdateBudgetDriver } from '../../../../../../features/budgetDrivers/queries/useUpdateBudgetDriver'

interface BudgetDriverModalProps {
  budgetDriver?: BudgetDriver
  visible: boolean
  handleCancel: () => void
}

const BudgetDriverModal: React.FC<BudgetDriverModalProps> = ({
  visible,
  budgetDriver,
  handleCancel
}: BudgetDriverModalProps) => {
  const { t } = useTranslation()
  const [form] = Form.useForm<BudgetDriver>()
  const { mutateAsync: createBudgetDriver, isPending: isCreating } = useCreateBudgetDriver()
  const { mutateAsync: updateBudgetDriver, isPending: isUpdating } = useUpdateBudgetDriver()

  useEffect(() => {
    form.setFieldsValue({ ...budgetDriver })
  }, [budgetDriver])

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      if (values.id) {
        await updateBudgetDriver(values)
      } else {
        await createBudgetDriver(values)
      }
      form.resetFields()
      handleCancel()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal
      title={t('menu:/settings/company/budgeting/drivers')}
      open={visible}
      maskClosable={false}
      okText={t('global:save')}
      cancelText={t('global:cancel')}
      confirmLoading={isCreating || isUpdating}
      onOk={handleSubmit}
      onCancel={() => {
        handleCancel()
      }}
    >
      <BudgetDriverForm form={form} />
    </Modal>
  )
}

export default BudgetDriverModal
